(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { BORDER, COLOR, SPACE } from "../../constants/style";
import { Flex } from "../layout";
import { Heading } from "../text";
import contrast from "../../themes/contrast";
import light from "../../themes/light";
import { ThemeProvider, themeWrapper } from "../themes";
var SegmentContentContainer = styled(Flex).withConfig({
  displayName: "Segment__SegmentContentContainer",
  componentId: "sc-1bthao5-0"
})(["width:100%;height:auto;"]);
var SegmentContent = styled(Flex).withConfig({
  displayName: "Segment__SegmentContent",
  componentId: "sc-1bthao5-1"
})([""]);
var SegmentContainer = styled(Flex).withConfig({
  displayName: "Segment__SegmentContainer",
  componentId: "sc-1bthao5-2"
})(["width:100%;flex-direction:column;padding:", ";", " ", " border-radius:", ";", " background-color:", ";color:", ";margin-top:", ";margin-bottom:", ";", ""], function (props) {
  return props.outlined ? SPACE[props.space] : 0;
}, function (props) {
  return props.padding ? "padding: ".concat(props.padding, ";") : '';
}, function (props) {
  return props.outlined && "border: 2px solid ".concat(COLOR.gray.lightest, ";");
}, BORDER.radius.sm, function (props) {
  if (!props.divided) {
    return;
  }

  var borderSides = {
    row: ['left', 'right'],
    column: ['top', 'bottom']
  };
  var sides = borderSides[props.direction];
  return "\n      & > ".concat(SegmentContentContainer, " > ").concat(SegmentContent, " {\n        flex: ").concat(props.direction === 'column' ? '1 0 auto' : '1 0 0', ";\n        padding: 0;\n        border-").concat(sides[0], ": 1px solid #f6f6f6;\n        border-").concat(sides[1], ": 1px solid #f6f6f6;\n        padding-").concat(sides[0], ": ").concat(SPACE[props.space], ";\n        padding-").concat(sides[1], ": ").concat(SPACE[props.space], ";\n      }\n      & > ").concat(SegmentContentContainer, " > ").concat(SegmentContent, ":first-child {\n        border-").concat(sides[0], ": 0;\n        padding-").concat(sides[0], ": 0;\n      }\n      & > ").concat(SegmentContentContainer, " > ").concat(SegmentContent, ":last-child {\n        border-").concat(sides[1], ": 0;\n        padding-").concat(sides[1], ": 0;\n      }\n    ");
}, function (props) {
  return props.theme.styles.colors.bodyBackgroundColor;
}, function (props) {
  return props.theme.styles.colors.bodyTextColor;
}, function (props) {
  return SPACE[props.space];
}, function (props) {
  return SPACE[props.space];
}, function (props) {
  return props.margin ? "margin: ".concat(props.margin, ";") : '';
});
var SegmentHeading = styled(Heading).withConfig({
  displayName: "Segment__SegmentHeading",
  componentId: "sc-1bthao5-3"
})(["font-weight:500;text-transform:uppercase;flex-direction:horizontal;text-align:center;letter-spacing:0.04em;color:", ";", " ", ""], function (props) {
  return props.theme.styles.colors.headings;
}, function (props) {
  return props.spacing && css(["margin-top:8px !important;margin-bottom:24px;"]);
}, function (props) {
  return props.notchedHeading && css(["margin-top:8px !important;margin-bottom:36px;display:flex;align-items:center;&:before,&:after{content:\"\";flex:1 0 auto;height:", ";background:", ";}&:before{margin-right:", ";}&:after{margin-left:", ";}"], BORDER.width.md, function (props) {
    return props.theme.styles.colors.divider;
  }, SPACE.xl, SPACE.xl);
});
var themes = {
  contrast: contrast,
  light: light
};

var ConditionalWrapper = function ConditionalWrapper(_ref) {
  var condition = _ref.condition,
      wrapper = _ref.wrapper,
      children = _ref.children;
  return condition ? wrapper(children) : children;
};

var Segment = function Segment(props) {
  var children = props.children,
      footer = props.footer,
      divided = props.divided,
      header = props.header,
      heading = props.heading,
      outlined = props.outlined,
      notchedHeading = props.notchedHeading,
      space = props.space,
      size = props.size,
      themeId = props.themeId,
      direction = props.direction,
      rest = _objectWithoutProperties(props, ["children", "footer", "divided", "header", "heading", "outlined", "notchedHeading", "space", "size", "themeId", "direction"]); // const {themeId, ...rest} = props


  return React.createElement(ConditionalWrapper, {
    condition: themeId,
    wrapper: function wrapper(children) {
      return React.createElement(ThemeProvider, {
        theme: themes[themeId]
      }, children);
    }
  }, React.createElement(SegmentContainer, _extends({
    outlined: outlined,
    notchedHeading: notchedHeading,
    space: space,
    size: size,
    divided: divided,
    direction: direction
  }, rest), header ? header : null, heading ? React.createElement(SegmentHeading, {
    level: notchedHeading ? 3 : 4,
    outlined: outlined,
    spacing: props.space,
    notchedHeading: notchedHeading
  }, heading) : null, React.createElement(SegmentContentContainer, {
    direction: direction
  }, React.Children.map(children, function (child) {
    return (// Don't render anything if child is null or something
      child ? React.createElement(SegmentContent, null, child) : null
    );
  })), footer ? footer : null));
};

Segment.propTypes = {
  direction: PropTypes.oneOf(['column', 'row']),
  space: PropTypes.oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  divided: PropTypes.bool,
  outlined: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  themeId: PropTypes.string,
  notchedHeading: PropTypes.bool
};
Segment.defaultProps = {
  divided: false,
  size: 'md',
  space: 'md',
  direction: 'column',
  outlined: false,
  notchedHeading: false
};

var _default = themeWrapper(Segment);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SegmentContentContainer, "SegmentContentContainer", "/home/vsts/work/1/s/src/components/containers/Segment.js");
  reactHotLoader.register(SegmentContent, "SegmentContent", "/home/vsts/work/1/s/src/components/containers/Segment.js");
  reactHotLoader.register(SegmentContainer, "SegmentContainer", "/home/vsts/work/1/s/src/components/containers/Segment.js");
  reactHotLoader.register(SegmentHeading, "SegmentHeading", "/home/vsts/work/1/s/src/components/containers/Segment.js");
  reactHotLoader.register(themes, "themes", "/home/vsts/work/1/s/src/components/containers/Segment.js");
  reactHotLoader.register(ConditionalWrapper, "ConditionalWrapper", "/home/vsts/work/1/s/src/components/containers/Segment.js");
  reactHotLoader.register(Segment, "Segment", "/home/vsts/work/1/s/src/components/containers/Segment.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/containers/Segment.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();